import Link from 'next/link';
 

const Footer = () => {
  const productLinks = [
    { id: 'footer_features', label: 'Features', href: '/homepage#features' },
    { id: 'footer_study', label: 'Study Modes', href: '/category-selection' },
  ]

  const resourceLinks = [
    { id: 'footer_help', label: 'Help Center', href: '#help' },
    { id: 'footer_docs', label: 'Documentation', href: '#docs' },
    { id: 'footer_faq', label: 'FAQs', href: '#faq' },
  ]

  const companyLinks = [
    { id: 'footer_about', label: 'About', href: '#about' },
    { id: 'footer_contact', label: 'Contact', href: '#contact' },
    { id: 'footer_privacy', label: 'Privacy', href: '#privacy' },
    { id: 'footer_terms', label: 'Terms', href: '#terms' },
  ]

  const socialLinks = [
    { id: 'footer_twitter', label: 'Twitter', href: '#twitter', icon: 'twitter' },
    { id: 'footer_facebook', label: 'Facebook', href: '#facebook', icon: 'facebook' },
    { id: 'footer_linkedin', label: 'LinkedIn', href: '#linkedin', icon: 'linkedin' },
  ]


  return (
    <footer className="w-full border-t border-border bg-background">
      <div className="container px-4 sm:px-6 py-8 sm:py-12">
        {/* Top Row - Link Groups */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Product Links */}
          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-foreground mb-2 sm:mb-3">Product</h3>
            <ul className="space-y-1.5 sm:space-y-2">
              {productLinks?.map((link) => (
                <li key={link?.id}>
                  <Link
                    href={link?.href}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resource Links */}
          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-foreground mb-2 sm:mb-3">Resources</h3>
            <ul className="space-y-1.5 sm:space-y-2">
              {resourceLinks?.map((link) => (
                <li key={link?.id}>
                  <Link
                    href={link?.href}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-xs sm:text-sm font-semibold text-foreground mb-2 sm:mb-3">Company</h3>
            <ul className="space-y-1.5 sm:space-y-2">
              {companyLinks?.map((link) => (
                <li key={link?.id}>
                  <Link
                    href={link?.href}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer